import React from "react";
import { InlineMath } from "react-katex";
const Section = ({ heading, items }) => {
  // const getC = (l) => (l > 9 ? "w-full flex-1" : "w-max");
  return (
    <>
      <h3 className="font-semibold text-xl underline mb-2 border-bottom ">
        {" "}
        <InlineMath math={heading} />
      </h3>
      <span className="w-full rounded-full h-0.5 bg-white opacity-50 "></span>
      <div className="w-full flex flex-wrap gap-2 mb-3">
        {items.split(", ").map((item) => (
          <kbd className={"kbd w-max "}>{item}</kbd>
        ))}
      </div>
    </>
  );
};

const MobileHelp = () => {
  return (
    <div className="w-full pt-4 gap-y-2 w-full relative m-auto grid grid-cols-1 gap-y-2">
      <Section
        heading={"\\sqrt{x}"}
        items={"square root of x, square root x, sqrt x"}
      />
      <Section heading={"("} items={"all, ("} />
      <Section heading={")"} items={"and, then, )"} />
      <Section heading={"x^2"} items={"x squared, x^2"} />
      <Section heading={"x^3"} items={"x cubed, x^3"} />
      <Section heading={"x^{y}"} items={"x to the power of y, x^y"} />
      <Section
        heading={"\\ln\\left(x\\right)"}
        items={"natural log of x, ln x"}
      />
      <Section
        heading={"\\int_x^{y} dθ"}
        items={"integral from x to y of dtheta, integral from x to y dtheta"}
      />
      <Section
        heading={"\\frac{d}{dx} \\tan\\left(\\theta\\right)"}
        items={"derivative of tangent of theta"}
      />
      <Section
        heading={"\\tan\\left(\\theta\\right)"}
        items={"tangent of theta, tangent theta, tan theta, tan(theta)"}
      />
      <Section
        heading={"\\sin\\left(\\theta\\right)"}
        items={"sine of theta, sine theta, sin theta, sin(theta)"}
      />
      <Section
        heading={"\\cos\\left(\\theta\\right)"}
        items={"cos of theta, cos theta, cos(theta)"}
      />
      <Section
        heading={"\\frac{1}{\\tan\\left(\\theta\\right)}"}
        items={"cotangent of theta, cot theta, cot(theta)"}
      />
      <Section
        heading={"\\frac{1}{\\sin\\left(\\theta\\right)}"}
        items={"cosecant of theta, csc theta, csc(theta)"}
      />
      <Section
        heading={"\\frac{1}{\\cos\\left(\\theta\\right)}"}
        items={"secant of theta, sec theta, sec(theta)"}
      />
      <Section
        heading={"\\frac{x}{y}"}
        items={"x over y, x downstairs y, x divided by y, x/y"}
      />
      <Section
        heading={"\\pi r"}
        items={"pi multiplied by r, pi times r, pi*r"}
      />
      <Section heading={"x+y"} items={"x plus y, x+y"} />
      <Section heading={"x-y"} items={"x minus y, x-y"} />
      <Section heading={"x=2"} items={"x equals 2, x=2"} />
    </div>
  );
};
export default MobileHelp;
